import { Content, PageWithHeader } from '@backstage/core-components';
import React, { ReactNode } from 'react';
import { DevxBreadCrumb } from '../../common/BreadcrumbsNav/DevxBreadCrumb';
import { useStyles } from '../pageContentStyles';
interface DesignToCodeLayout {
  children?: ReactNode;
  breadcrumb?: any;
}

const rootBreadcrumb = [
  {
    type: 'text',
    link: '',
    text: 'Design to Code',
  },
];

const DesignToCodeLayout = ({
  children,
  breadcrumb = rootBreadcrumb,
}: DesignToCodeLayout) => {
  const classes = useStyles();
  return (
    <div className="design-to-code-layout-container">
      <PageWithHeader
        title="Design to Code"
        themeId="home"
        subtitle={
          <DevxBreadCrumb
            routes={[{ type: 'link', link: '/', text: 'Home' }, ...breadcrumb]}
          />
        }
      >
        <Content>
          <div className={classes.customPageContent}>{children}</div>
        </Content>
      </PageWithHeader>
    </div>
  );
};

export default DesignToCodeLayout;
